
import React, { useLayoutEffect } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Slide } from '@mui/material';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import EditTagQuestion from '../EditTagQuestion';
import { QuestionProps } from '../../typings/register';
import { TransitionProps } from '@mui/material/transitions';
import QuestionUpdateHeader from '../../pages/MyProfile/components/QuestionUpdateHeader';
import EditTagsQuestion from '../EditTagsQuestion';

export type QuestionSelectModalProps = {
    question: QuestionProps
    onNext: any;
    primaryButtonText: string;
    selectedQuestionTags: any
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="right" ref={ref} {...props} />;
});

const QuestionSelectModal = NiceModal.create(({ selectedQuestionTags, onNext, question, primaryButtonText }: QuestionSelectModalProps) => {
    const modal = useModal();
    const location = useLocation();
    const history = useHistory();
    const openModalHashStateId = `${location.pathname}${location.search}&popup=AdvancedSearchQuestion`;

    useLayoutEffect(() => {
        const listen = history.listen(historyBack);
        if (modal.visible) {
            window.history.pushState({ openModalHashStateId }, `${openModalHashStateId}`, `${openModalHashStateId}`)
        }
        return () => listen();
    }, [modal.visible])

    const historyBack = () => {
        modal.hide();
    }

    const handleModalToggle = () => {
        history.goBack();
        modal.hide();
    };

    const handleOnNext = (value: number[]) => {

        onNext(question.questionId, value);
        handleModalToggle();
    }

    return (
        <>
            <div>
                <Dialog
                    fullScreen={true}
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
                    open={modal.visible}
                    TransitionComponent={Transition}
                    onClose={handleModalToggle}
                >
                    <div>
                        <QuestionUpdateHeader />
                        <EditTagsQuestion
                            onSave={handleOnNext}
                            questionMinAsnwer={question.minAnswer}
                            questionMaxAsnwer={question.maxAnswer}
                            title={question.question}
                            subtitle={""}
                            tags={question.tags ?? []}
                            selectedTagsValue={selectedQuestionTags?.questionTag}
                            buttonText={"בחר וחזור להעדפות חיפוש"}
                            questionId={question.questionId}
                        />
                    </div>
                </Dialog>
            </div>
        </>


    )
})


export default QuestionSelectModal;